import DocFirmatoView from "./DocFirmatoView";
import {useContext, useState} from "react";
import {RuoliContext} from "../../../../../context/RuoliContext";
import {LoaderContext} from "../../../../../context/LoaderContext";
import {deleteDocumentoFirmatoApi} from "../../../../../services/CertificatiServices";

export default function DocFirmatoController({
                                                 documento,
                                                 onUpdate,
                                             }) {

    const [show, setShow] = useState(false);

    const {isRuoloAdmin, isRuoloSegreteria} = useContext(RuoliContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const downloadDocumento = (doc, download) => {
        if (download === true) {
            var a = document.createElement("a"); //Create <a>
            a.href = "data:" + doc.content_type + ";base64," + doc.contenuto; //Image Base64 Goes here
            a.download = doc.nome_file_originale; //File name Here
            a.click(); //Downloaded file
        } else {
            var byteCharacters = atob(doc.contenuto);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {type: doc.content_type + ';base64'});
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
    }

    const eliminaDocumento = async () => {
        setShow(false);
        startChiamata();

        const response = await deleteDocumentoFirmatoApi(documento.id_certificato, documento.id_documento_certificato_firmato);
        onUpdate(response.data);
        endChiamata();
    }

    const showConfirmEliminaDocumento = () => {
        setShow(true);
    }

    const hideConfirmEliminaDocumento = () => {
        setShow(false);
    }

    return (
        <DocFirmatoView
            documento={documento}
            isRuoloAdmin={isRuoloAdmin}
            isRuoloSegreteria={isRuoloSegreteria}
            downloadDocumento={downloadDocumento}
            eliminaDocumento={eliminaDocumento}
            show={show}
            showConfirmEliminaDocumento={showConfirmEliminaDocumento}
            hideConfirmEliminaDocumento={hideConfirmEliminaDocumento}
        />
    );

}